class FreeGiftManager {
  constructor() {
    this.threshold = 69900;
    this.giftVariantId =  window.freeGiftSettings.variantId;

    this.isProcessing = false;
    this.lastAction = null;

    document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));

    this.initialize();
  }

  async initialize() {
    try {
      const cart = await this.getCart();
      this.processCart(cart);
    } catch (error) {
      console.error('Free gift init error:', error);
    }
  }

  async handleCartUpdate(event) {
    if (this.isProcessing) return;

    try {
      let cartData = null;

      if (event.detail?.cart) {
        try {
          cartData = JSON.parse(event.detail.cart);
        } catch (e) {}
      }

      if (!cartData) {
        cartData = await this.getCart();
      }

      await this.processCart(cartData);
    } catch (error) {
      console.error('Free gift update error:', error);
    }
  }

  async processCart(cart) {
    if (this.isProcessing) return;

    const giftItem = this.findGiftItem(cart);

    const eligibleTotal = this.getEligibleTotal(cart);

    const qualifies = eligibleTotal >= this.threshold;

    if (qualifies && !giftItem) {
      await this.addGift();
      return;
    }

    if (!qualifies && giftItem) {
      await this.removeGift(giftItem.key);
    }
  }

  getEligibleTotal(cart) {
    return cart.items.reduce((total, item) => {
      if (item.properties?._free_gift) {
        return total;
      }

      return total + item.final_line_price;
    }, 0);
  }

  findGiftItem(cart) {
    return cart.items.find((item) => {
      return (
        item.variant_id == this.giftVariantId ||
        item.properties?._free_gift
      );
    });
  }

  async addGift() {
    if (this.isProcessing || this.lastAction === 'adding') return;

    this.isProcessing = true;
    this.lastAction = 'adding';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: this.giftVariantId,
              quantity: 1,
              properties: {
                _free_gift: 'true'
              }
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add free gift');
      }

      await this.refreshCartSections();

    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
        this.lastAction = null;
      }, 300);
    }
  }

  async removeGift(lineItemKey) {
    if (this.isProcessing || this.lastAction === 'removing') return;

    this.isProcessing = true;
    this.lastAction = 'removing';

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error('Failed to remove free gift');
      }

      await this.refreshCartSections();

    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
        this.lastAction = null;
      }, 300);
    }
  }

  async refreshCartSections() {
    const response = await fetch(
      `${window.location.pathname}?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble`
    );

    const sections = await response.json();

    const miniCart = document.getElementById('mini-cart');

    if (miniCart && sections['mini-cart']) {
      miniCart.innerHTML = this.extractHTML(
        sections['mini-cart'],
        '.shopify-section'
      );
    }

    const cartBubble = document.getElementById('cart-icon-bubble');

    if (cartBubble && sections['cart-icon-bubble']) {
      cartBubble.innerHTML = this.extractHTML(
        sections['cart-icon-bubble'],
        '.shopify-section'
      );
    }

    const mobileBubble = document.getElementById('mobile-cart-icon-bubble');

    if (mobileBubble && sections['mobile-cart-icon-bubble']) {
      mobileBubble.innerHTML = this.extractHTML(
        sections['mobile-cart-icon-bubble'],
        '.shopify-section'
      );
    }
  }

  extractHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  async getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }
}

window.freeGiftManager = new FreeGiftManager();